import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-weight-medium" }
const _hoisted_2 = { class: "mr-1" }

import { useWorkspaceStore } from '../stores/workspaceStore'

interface LeaderboardEntry {
  rank: number
  name: string
  points: number
  slackId: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LeaderboardTable',
  props: {
    entries: {}
  },
  setup(__props: any) {

const headers = [
  { title: 'Rank', key: 'rank', align: 'start' as const, sortable: false },
  { title: 'Handle', key: 'name', align: 'start' as const, sortable: false },
  { title: 'Tokens', key: 'points', align: 'start' as const, sortable: false }
] as const

const { getWorkspaceEmoji } = useWorkspaceStore()
const workspaceEmoji = getWorkspaceEmoji()



return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_data_table, {
    headers: headers,
    items: _ctx.entries,
    "items-per-page": 10,
    density: "compact",
    hover: "",
    class: "elevation-0"
  }, {
    "no-data": _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "text-center pa-4 text-medium-emphasis" }, " No entries yet ", -1)
    ]))]),
    "item.rank": _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(item.rank), 1)
    ]),
    "item.points": _withCtx(({ item }) => [
      _createVNode(_component_v_chip, {
        color: "primary",
        variant: "flat",
        size: "small",
        class: "font-weight-medium"
      }, {
        prepend: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(workspaceEmoji).emojiSymbol || '🙏'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(item.points), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["items"]))
}
}

})